import { MarketScheduleURL } from '../constants';
export function GetMarketSchedule(api) {
    return () => {
        return api.get(MarketScheduleURL, {});
    };
}
//# sourceMappingURL=marketSchedule.js.map